import { useCallback } from 'react';

import { useAppDispatch } from 'src/app/store/hooks';
import {
  DispatchAssignmentRead,
  DispatchTripRead,
} from 'src/common/external/bambi-api/bambiApi';
import { RouteTemplateDataRead } from 'src/common/external/bambi-api/routesApi';

import { routeTemplateActions } from '../routeTemplates.slice';

export function useEditRouteTemplateModal() {
  const dispatch = useAppDispatch();
  const editRouteTemplateModal = useCallback(
    (routeTemplate: Partial<RouteTemplateDataRead> | undefined) => {
      dispatch(routeTemplateActions.setEditingRouteTemplate(routeTemplate));
      dispatch(routeTemplateActions.setShowRouteTemplateForm(true));
    },
    [dispatch]
  );

  const editBulkRouteTemplateModal = useCallback(
    (
      bulkAssignments: DispatchAssignmentRead[],
      bulkTrips: DispatchTripRead[]
    ) => {
      dispatch(
        routeTemplateActions.setBulkCreationData({
          bulkCreationAssignments: bulkAssignments,
          bulkCreationTrips: bulkTrips,
        })
      );
      dispatch(routeTemplateActions.setShowRouteTemplateForm(true));
    },
    [dispatch]
  );

  return {
    editRouteTemplateModal,
    editBulkRouteTemplateModal,
  };
}
